var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:Object.assign({}, {'mt-5': _vm.hasMarginTop, 'text-light': _vm.color === 'light'}, _vm.displayClasses)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }